import { IPassport } from "#src/services/endpoint/passports/types";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";

// Local components and hooks
import { usePassportForm } from "./hooks/usePassportForm";
import { PassportFormFields } from "./components/PassportFormFields";
import { PassportModalFooter } from "./components/PassportModalFooter";

type Props = {
  isOpen: boolean;
  workspaceId: string;
  selectedPassport?: IPassport | null;
  closeModal: () => void;
  onEditSuccess: (newData: IPassport) => void;
  onAddSuccess: (newData: IPassport) => void;
};

const AddEditPassportModal = (props: Props) => {
  const {
    isOpen,
    workspaceId,
    selectedPassport,
    onEditSuccess,
    onAddSuccess,
    closeModal,
  } = props;

  const formState = usePassportForm({
    isOpen,
    workspaceId,
    selectedPassport,
    onEditSuccess,
    onAddSuccess,
    closeModal,
  });

  const {
    isLoading,
    type,
    setType,
    action,
    setAction,
    ports,
    setPorts,
    destinations,
    setDestinations,
    sources,
    setSources,
    timeFrameEnabled,
    setTimeFrameEnabled,
    timeFrameType,
    setTimeFrameType,
    timeFrameRepeatEvery,
    setTimeFrameRepeatEvery,
    timeFrameStartTime,
    setTimeFrameStartTime,
    timeFrameEndTime,
    setTimeFrameEndTime,
    timeFrameRepeatOn,
    setTimeFrameRepeatOn,
    timeFrameRepeatOnDate,
    setTimeFrameRepeatOnDate,
    isEditing,
    isDataValid,
    handleSaveOrAdd,
    clearAllSearchInputs,
    sourcesInputRef,
    destinationsInputRef,
    portsInputRef,
    t,
  } = formState;

  // --------------- RENDER ---------------
  return (
    <ModalV2
      open={isOpen}
      onChangeOpen={() => {
        clearAllSearchInputs();
        closeModal();
      }}
      className="max-w-[760px] w-[90%]"
    >
      <span className="text-lg font-semibold text-gray-v2-900">
        {t(`modal.addAndEdit.title.${isEditing ? "edit" : "add"}`)}
      </span>
      <div className="v2">
        <PassportFormFields
          workspaceId={workspaceId}
          type={type}
          setType={setType}
          action={action}
          setAction={setAction}
          sources={sources}
          setSources={setSources}
          destinations={destinations}
          setDestinations={setDestinations}
          ports={ports}
          setPorts={setPorts}
          timeFrameEnabled={timeFrameEnabled}
          setTimeFrameEnabled={setTimeFrameEnabled}
          timeFrameType={timeFrameType}
          setTimeFrameType={setTimeFrameType}
          timeFrameRepeatEvery={timeFrameRepeatEvery}
          setTimeFrameRepeatEvery={setTimeFrameRepeatEvery}
          timeFrameStartTime={timeFrameStartTime}
          setTimeFrameStartTime={setTimeFrameStartTime}
          timeFrameEndTime={timeFrameEndTime}
          setTimeFrameEndTime={setTimeFrameEndTime}
          timeFrameRepeatOn={timeFrameRepeatOn}
          setTimeFrameRepeatOn={setTimeFrameRepeatOn}
          timeFrameRepeatOnDate={timeFrameRepeatOnDate}
          setTimeFrameRepeatOnDate={setTimeFrameRepeatOnDate}
          sourcesInputRef={sourcesInputRef}
          destinationsInputRef={destinationsInputRef}
          portsInputRef={portsInputRef}
        />

        <PassportModalFooter
          isEditing={isEditing}
          isDataValid={isDataValid}
          isLoading={isLoading}
          onSave={handleSaveOrAdd}
          onCancel={() => {
            clearAllSearchInputs();
            closeModal();
          }}
        />
      </div>
    </ModalV2>
  );
};

export default AddEditPassportModal;
